// extracted by mini-css-extract-plugin
export default {"container":"R4Hnsm","iconWrapper":"AP2ypu"};